/**
 * Creates a BusinessContext from a string.
 *
 * This is a compile-time type assertion with no runtime overhead.
 * Validation of whether the context exists happens at repository lookup,
 * not at creation time.
 *
 * @param value - The string to convert to a BusinessContext
 * @returns A BusinessContext
 */
export function createBusinessContext(value) {
    return value;
}
//# sourceMappingURL=BusinessContext.js.map